import jsPDF from "jspdf";
import { parseBoldSegments } from "./crearMensajesFormatting";

function createPdfWriter(doc) {
  const marginLeft = 40;
  const maxWidth = 515;
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 50;

  const ensureSpace = (needed = 40) => {
    if (y + needed > pageHeight - 50) {
      doc.addPage();
      y = 50;
    }
  };

  const addTitle = (text) => {
    ensureSpace(36);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(text, marginLeft, y);
    y += 22;
  };

  const addSectionTitle = (text) => {
    ensureSpace(28);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    const lines = doc.splitTextToSize(text, maxWidth);
    lines.forEach((line) => {
      ensureSpace(18);
      doc.text(line, marginLeft, y);
      y += 16;
    });
    y += 4;
  };

  const addBody = (text) => {
    if (!String(text ?? "").trim()) return;
    const fontSize = 10;
    const lineHeight = 13;
    doc.setFontSize(fontSize);

    const writeLine = (lineSegments) => {
      let x = marginLeft;
      ensureSpace(lineHeight + 4);
      lineSegments.forEach(({ text: chunk, bold }) => {
        doc.setFont("helvetica", bold ? "bold" : "normal");
        doc.text(chunk, x, y);
        x += doc.getTextWidth(chunk);
      });
      y += lineHeight;
    };

    const wrapSegments = (segments) => {
      const lines = [[]];
      let lineWidth = 0;

      segments.forEach((segment) => {
        doc.setFont("helvetica", segment.bold ? "bold" : "normal");
        const words = segment.text.split(/(\s+)/).filter(Boolean);

        words.forEach((word) => {
          const wordWidth = doc.getTextWidth(word);
          if (lineWidth + wordWidth > maxWidth && lineWidth > 0) {
            lines.push([]);
            lineWidth = 0;
          }
          lines[lines.length - 1].push({ text: word, bold: segment.bold });
          lineWidth += wordWidth;
        });
      });

      return lines.filter((line) => line.length > 0);
    };

    String(text)
      .split(/\n+/)
      .forEach((paragraph, index, all) => {
        const segments = parseBoldSegments(paragraph.trim());
        wrapSegments(segments).forEach(writeLine);
        if (index < all.length - 1) y += 4;
      });

    y += 10;
  };

  return { addTitle, addSectionTitle, addBody, marginLeft };
}

export function exportCrearMensajesPdf({
  t,
  introTipo,
  introTextos,
  introOpciones,
  collar,
  mensajes,
  conclusionBloques,
  conclusionValues,
}) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const { addTitle, addSectionTitle, addBody } = createPdfWriter(doc);

  addTitle(t("sidebar.CrearMensajes"));

  addSectionTitle(
    `${t("crearMensajes.sections.intro.label")}: ${introOpciones[introTipo]?.label ?? ""}`,
  );
  addBody(introTextos[introTipo]);

  addSectionTitle(t("crearMensajes.sections.collar.label"));
  addBody(collar);

  mensajes.forEach((msg) => {
    addSectionTitle(
      t("crearMensajes.sections.mensaje.label", { step: msg.step }) +
        ` — ${msg.titulo}`,
    );
    addBody(msg.cuerpo);
  });

  addSectionTitle(t("crearMensajes.sections.conclusion.label"));
  conclusionBloques.forEach((bloque) => {
    addSectionTitle(bloque.title);
    addBody(conclusionValues[bloque.key]);
  });

  doc.save(t("crearMensajes.pdfFileName"));
}
